/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import { withMemo } from 'fierry/react.old';

import ResourceEnum from 'astro/enum/resource';

import Center from 'astro/react/map/zone/center';

import Building from 'astro/react/map/entity/building';
import Resource from 'astro/react/map/entity/resource';
import SectorCenter from 'astro/react/map/entity/sector.center';
import Unit from 'astro/react/map/entity/unit';


const Component = (props) =>
{
  const { zone, currentUser } = props;

  if (zone.getCass().getResource() != null)
  {
    return <Center local {...props} > <Resource {...props} /> </Center>;
  }

  if (zone.getEntity())
  {
    return <Center local {...props} > <Building {...props} /> </Center>;
  }

  if (zone.getUnit())
  {
    return <Center local {...props} > <Unit {...props} /> </Center>;
  }

  // TODO would be easier if sector could return Empty building (for currentUser only ?).
  /*if (zone.getCass().isCenter() && currentUser && zone.getUserID() === currentUser.getID() && !currentUser.isAncientUser())
  {
    return <Center local {...props} > <SectorCenter {...props} /> </Center>;
  }*/

  return null;
};


export default withMemo((props) =>
{
  const { zone } = props;

  return <Component {...props} location = {zone.getLocation()} />;
})
